import { TableColumnDirective } from '../directives/table-column.directive';
import { TableFilterFactory } from './table-filter';

import {
  SortState,
  TableColumnEvent,
  TableStateEvent,
  TableColumnSortOption,
  Filter,
} from './types';

export class TableState {
  constructor(
    public readonly sort: SortState,
    public readonly searchText: string,
    public readonly searchField: string,
    public filter: Filter<Record<string, unknown>>[] = []
  ) {}

  public static from(
    event: TableStateEvent,
    columns: TableColumnDirective[]
  ): TableState {
    const filters = new TableFilterFactory(event.filter, columns).create();
    return new TableState(event.sort, '', '', filters);
  }

  public static empty(): TableState {
    return new TableState({ field: '', type: 'none' }, '', '');
  }

  public sorted(field: string): TableColumnSortOption {
    return this.sort.field === field ? this.sort.type : 'none';
  }

  public filtered(field: string): Filter<Record<string, unknown>>[] {
    return this.filter.filter((f) => f.match(field));
  }

  public update(event: TableColumnEvent): TableState {
    const sort = { field: event.field, type: event.sort };

    if (event.field === '') {
      return new TableState(
        sort,
        this.searchText,
        this.searchField,
        this.filter
      );
    }

    this.filter = [
      ...this.filter.filter((f) => !f.match(event.field)),
      ...event.filter,
    ];

    const searchText = event.searchText || '';
    const searchField = event.searchField || '';

    return new TableState(sort, searchText, searchField, this.filter);
  }

  public event(): TableStateEvent {
    const filter = this.filter.map((f) => f.values());
    return {
      sort: this.sort,
      filter,
      searchText: this.searchText,
      searchField: this.searchField,
    };
  }
}
